/**参数说明：
 * 根据长度截取先使用字符串，超长部分追加…
 * str 对象字符串
 * len 目标字节长度
 * 返回值： 处理结果字符串
 */
export const CutString = (str, len) => {
  if (str.length * 2 <= len) { //length属性读出来的汉字长度为1
    return str;
  }
  let strlen = 0;
  let s = "";
  for (let i = 0; i < str.length; i++) {
    s = s + str.charAt(i);
    if (str.charCodeAt(i) > 128) {
      strlen = strlen + 2;
      if (strlen >= len) {
        return s.substring(0, s.length - 1) + "...";
      }
    } else {
      strlen = strlen + 1;
      if (strlen >= len) {
        return s.substring(0, s.length - 2) + "...";
      }
    }
  }
  return s;
};
//分享
export const socialShare = (type, info) => {
  let shareUrl = "";
  let { url, title, source, desc, image, summary } = info;
  switch (type) {
    case "qq":
      shareUrl = `http://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}&source=${source}&desc=${desc}&pics=${image}&summary="${summary}"`;
      break;
    case "wx":
      shareUrl = url;
      break;
    case "wb":
      shareUrl = `https://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${image}&appkey=`;
      break;
    case "kj":
      shareUrl = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}}&source=${source}&desc=${desc}&pics=${image}&summary=${summary}`;
      break;
    default:
      shareUrl = url;
  }
  return shareUrl;
};

//计算两个时间之间的时间差 多少天时分秒
export const intervalTime = (startTime, endTime) => {
  // var timestamp=new Date().getTime(); //计算当前时间戳

  var timestamp = (Date.parse(new Date())) / 1000;//计算当前时间戳 (毫秒级)

  var date1 = ""; //开始时间
  if (timestamp < startTime) {
    date1 = startTime;
  } else {
    date1 = timestamp; //开始时间
  }
  var date2 = endTime; //结束时间

  // var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
  var date3 = (date2 - date1) * 1000; //时间差的毫秒数
  //计算出相差天数
  var days = Math.floor(date3 / (24 * 3600 * 1000));
  //计算出小时数

  var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));

  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000));

  //计算相差秒数
  var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000);

  //console.log(days + "天 " + hours + "小时 ")
  return days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒"
  //return   days + "天 " + hours + "小时 "
}



// 时间显示  多久前


// WEBPACK FOOTER //
// ./src/modules/common.js